import React from 'react'
import './AboutMe.css'
import { Typography } from '@material-ui/core';
import Image from './img/profile.jpg';

function AboutMe() {
    return (
        <div className="aboutme">
            <img class="aboutme-img"src={Image} alt="Profile" />
            <div className="aboutme-text">
                <Typography>
                    Hi! My Name is Faisal Rahman.
                </Typography>
                <Typography>
                    I love learning new technologies and bulding projects which makes life of human beings easier. This project "Realtime 
                    COVID-19 Tracker" is developed using React JS and is made with the sole purpose to stay updated with
                    corona virus cases throughout the world. 
                </Typography>
                <Typography>
                    <a className="aboutme-mail" href="mailto:faisalsaysin@gmail.com">Contact Me</a>
                </Typography>
            </div>
        </div>
    )
}

export default AboutMe
